import React from 'react';
import Table from 'core/components/VirtualTable';
import columns from 'pages/Dashboard/pages/Forms/pages/FormWorkflow/Overview/columns';
import {
  FormWorkflowRow,
  ListQueryProps,
} from 'pages/Dashboard/pages/Forms/pages/FormWorkflow/types';
import {
  getFormWorkflowsData,
} from 'pages/Dashboard/pages/Forms/pages/FormWorkflow/transport';
import {
  useMedia,
  useSidePanel,
} from 'core/hooks';

export default function QueryTable({
  dateRange,
  filterQuery = {},
  tableInstanceRef,
  searchQuery,
}: ListQueryProps) {
  const { requestMedia } = useMedia();
  const { openPanel } = useSidePanel();

  return (
    <Table<FormWorkflowRow>
      instanceRef={tableInstanceRef}
      getData={getFormWorkflowsData}
      getRowId={(row) => row.formWorkflowId ?? 0}
      columns={columns}
      classes={{
        header: 'px-4 !justify-between',
        outerRow: '!w-[calc(100%-16px)] left-4',
        row: '!justify-between',
      }}
      queryParams={{
        filterQuery,
        dateRange,
        requestMedia,
        searchQuery,
      }}
      onRowClick={(table, row) => {
        openPanel('formWorkflow', { formWorkflowId: Number(row.id) });
      }}
      defaultPagination={{
        pageSize: 25,
        pageIndex: 0,
      }}
      loadingSlot="Loading form workflows..."
      emptySlot="No form workflows found."
    />
  );
}
